import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  labelKey?: string;
  path?: string;   // if present → clickable, if absent → current page
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {

  // BehaviorSubject holds current breadcrumb state
  private breadcrumbs$ = new BehaviorSubject<BreadcrumbItem[]>([]);

  // exposed as observable for component to subscribe
  breadcrumbs = this.breadcrumbs$.asObservable();

  private expandGroup$ = new BehaviorSubject<string>('');
  expandGroup = this.expandGroup$.asObservable();

  // set new breadcrumb
  set(items: BreadcrumbItem[]) {
    this.breadcrumbs$.next(items);
  }

  //  ADD THIS
  setExpandGroup(group: string) {
    this.expandGroup$.next(group);
  }

  // ADD THIS
  getExpandGroup(): string {
    return this.expandGroup$.getValue();
  }

  clearExpandGroup() {
    this.expandGroup$.next('');
  }

  // clear breadcrumb
  clear() {
    this.breadcrumbs$.next([]);
  }


}